function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, shallowRef, computed, onBeforeUnmount, provide, toRef, openBlock, createElementBlock, unref, createBlock, createSlots, withCtx, createVNode, mergeProps, renderSlot, createCommentVNode } from 'vue';
import '../../form/index.mjs';
import { uploadContextKey } from './constants.mjs';
import UploadList from './upload-list2.mjs';
import UploadContent from './upload-content2.mjs';
import { useHandlers } from './use-handlers.mjs';
import { uploadProps } from './upload.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useFormDisabled } from '../../form/src/hooks/use-form-common-props.mjs';
const __default__ = defineComponent({
  name: "ElUpload"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: uploadProps,
  setup(__props, _ref) {
    let expose = _ref.expose;
    const props = __props;
    const disabled = useFormDisabled();
    const uploadRef = shallowRef();
    const _useHandlers = useHandlers(props, uploadRef),
      abort = _useHandlers.abort,
      submit = _useHandlers.submit,
      clearFiles = _useHandlers.clearFiles,
      uploadFiles = _useHandlers.uploadFiles,
      handleStart = _useHandlers.handleStart,
      handleError = _useHandlers.handleError,
      handleRemove = _useHandlers.handleRemove,
      handleSuccess = _useHandlers.handleSuccess,
      handleProgress = _useHandlers.handleProgress,
      revokeFileObjectURL = _useHandlers.revokeFileObjectURL;
    const isPictureCard = computed(() => props.listType === "picture-card");
    const uploadContentProps = computed(() => _objectSpread(_objectSpread({}, props), {}, {
      fileList: uploadFiles.value,
      onStart: handleStart,
      onProgress: handleProgress,
      onSuccess: handleSuccess,
      onError: handleError,
      onRemove: handleRemove
    }));
    onBeforeUnmount(() => {
      uploadFiles.value.forEach(revokeFileObjectURL);
    });
    provide(uploadContextKey, {
      accept: toRef(props, "accept")
    });
    expose({
      abort,
      submit,
      clearFiles,
      handleStart,
      handleRemove
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [unref(isPictureCard) && _ctx.showFileList ? (openBlock(), createBlock(UploadList, {
        key: 0,
        disabled: unref(disabled),
        "list-type": _ctx.listType,
        files: unref(uploadFiles),
        "handle-preview": _ctx.onPreview,
        onRemove: unref(handleRemove)
      }, createSlots({
        append: withCtx(() => [createVNode(UploadContent, mergeProps({
          ref_key: "uploadRef",
          ref: uploadRef
        }, unref(uploadContentProps)), {
          default: withCtx(() => [_ctx.$slots.trigger ? renderSlot(_ctx.$slots, "trigger", {
            key: 0
          }) : createCommentVNode("v-if", true), !_ctx.$slots.trigger && _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", {
            key: 1
          }) : createCommentVNode("v-if", true)]),
          _: 3
        }, 16)]),
        _: 2
      }, [_ctx.$slots.file ? {
        name: "default",
        fn: withCtx(_ref2 => {
          let file = _ref2.file;
          return [renderSlot(_ctx.$slots, "file", {
            file
          })];
        })
      } : void 0]), 1032, ["disabled", "list-type", "files", "handle-preview", "onRemove"])) : createCommentVNode("v-if", true), !unref(isPictureCard) || unref(isPictureCard) && !_ctx.showFileList ? (openBlock(), createBlock(UploadContent, mergeProps({
        key: 1,
        ref_key: "uploadRef",
        ref: uploadRef
      }, unref(uploadContentProps)), {
        default: withCtx(() => [_ctx.$slots.trigger ? renderSlot(_ctx.$slots, "trigger", {
          key: 0
        }) : createCommentVNode("v-if", true), !_ctx.$slots.trigger && _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", {
          key: 1
        }) : createCommentVNode("v-if", true)]),
        _: 3
      }, 16)) : createCommentVNode("v-if", true), _ctx.$slots.trigger ? renderSlot(_ctx.$slots, "default", {
        key: 2
      }) : createCommentVNode("v-if", true), renderSlot(_ctx.$slots, "tip"), !unref(isPictureCard) && _ctx.showFileList ? (openBlock(), createBlock(UploadList, {
        key: 3,
        disabled: unref(disabled),
        "list-type": _ctx.listType,
        files: unref(uploadFiles),
        "handle-preview": _ctx.onPreview,
        onRemove: unref(handleRemove)
      }, createSlots({
        _: 2
      }, [_ctx.$slots.file ? {
        name: "default",
        fn: withCtx(_ref3 => {
          let file = _ref3.file;
          return [renderSlot(_ctx.$slots, "file", {
            file
          })];
        })
      } : void 0]), 1032, ["disabled", "list-type", "files", "handle-preview", "onRemove"])) : createCommentVNode("v-if", true)]);
    };
  }
}));
var Upload = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "upload.vue"]]);
export { Upload as default };